function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

import { get } from 'lodash';

var PersonDetails = function PersonDetails($filter) {
    var _this = this;

    _classCallCheck(this, PersonDetails);

    this.$onInit = function () {

        var phoneType = get(_this, 'contactModel.primaryPhoneType.value.code');

        _this.phoneLabels = {
            home: $filter('translate')('gateway.contacts.components.ContactDetailsPerson.home' + (phoneType === 'home' ? ' primary' : '')),
            work: $filter('translate')('gateway.contacts.components.ContactDetailsPerson.work' + (phoneType === 'work' ? ' primary' : '')),
            mobile: $filter('translate')('gateway.contacts.components.ContactDetailsPerson.mobile' + (phoneType === 'mobile' ? ' primary' : ''))
        };
    };
};

PersonDetails.$inject = ['$filter'];

export default PersonDetails;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/contacts/common/components/ContactDetailsPerson/ContactDetailsPersonCtrl.js
// module id = 1616
// module chunks = 0